module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/other-kp/component/other-kp-main/other-kp-main-modal-mnn/other-kp-main-modal-mnn.component.sass
// module id = ./src/app/modules/other-kp/component/other-kp-main/other-kp-main-modal-mnn/other-kp-main-modal-mnn.component.sass
// module chunks = main